<app-page-header title="function.About" translateTitle="true" icon="info"></app-page-header>

<div class="page-content">
    <div [@fadeInOut]>
        <h4>Versionhistorik</h4>

        <h5>1.0 - 2018-06-05</h5>
        <p>Första versionen</p>
        <h5>2.0 - 2020-07-14</h5>
        <p>Lagt till standarder, ny rapportmall som kan användas för nya metodversioner</p>
        <h5>2.1 - 2020-08-20</h5>
        <p>Plattformsuppdatering, smärre visuella förändringar.</p>
        <h5>2.2 - 2021-11-22</h5>
        <p>Plattformsuppdatering: .NET 5 Angular 11</p>
        <h5>2.3 - 2022-11-24</h5>
        <p>Plattformsuppdatering: .NET 6 Angular 14</p>
        <h5>2.4 - 2023-11-01</h5>
        <p>Plattformsuppdatering: Angular 16</p>
        <h5>2.5 - 2024-11-21</h5>
        <p>Plattformsuppdatering: Angular 18</p>
        <h5>2.6 - 2025-08-27</h5>
        <p>Plattformsuppdatering: .NET 8 Angular 19, ny OIDC provider</p>
        <h5>3.0 - 2026-07-23</h5>
        <p>Plattformsuppdatering: .NET 10 Angular 22, separat front-end app, key vault integration</p>
    </div>
</div>
